import { render, staticRenderFns } from "./add-review-notification.vue?vue&type=template&id=228f7426&"
import script from "./add-review-notification.vue?vue&type=script&lang=js&"
export * from "./add-review-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228f7426')) {
      api.createRecord('228f7426', component.options)
    } else {
      api.reload('228f7426', component.options)
    }
    module.hot.accept("./add-review-notification.vue?vue&type=template&id=228f7426&", function () {
      api.rerender('228f7426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/review/add-review-notification.vue"
export default component.exports